var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NuxtImg',{staticClass:"small-carousel-shadow",attrs:{"provider":"storyblok","src":_vm.blok.photo,"alt":_vm.blok.alt,"width":"100","height":"100"}})
}
var staticRenderFns = []

export { render, staticRenderFns }